import * as posixPath from './posix_path';
export * from './posix_path';
export const posix = posixPath;
// XXX: Typing hack: Exported so the type of this module matches NodeJS's path.
export const win32 = posixPath;
//# sourceMappingURL=path.js.map